

















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
  computed: {},
})
export default class RFIDReaderListener extends Vue {
  code = ''
  finalCode = ''
  fromScanner = false
  reading = false

  @Prop({ default: 3 }) minLength: any

  mounted() {
    document.addEventListener('keypress', this.documentKeyboardListener)

    this.$nextTick(() => {
      ;(document.activeElement as HTMLElement).blur()
    })
  }

  beforeDestroy() {
    document.removeEventListener('keypress', this.documentKeyboardListener)
  }

  documentKeyboardListener(e) {
    if (e.target.nodeName !== 'BODY') {
      return
    }

    if (e.code === 'Enter') {
      if (this.reading && this.code.length >= this.minLength) {
        // const ramdonList = [
        //   '10888',
        //   '8000000000000027',
        //   '8000000000000024',
        //   '8000000000000023',
        //   '231231223123',
        //   '132123123',
        // ]
        // const codeFake = ramdonList[Math.floor(Math.random() * ramdonList.length)]

        this.$emit('onScanner', this.code)

        this.finalCode = this.code
        this.code = ''
        this.fromScanner = true
      }
    } else {
      this.code += e.key // while this is not an 'enter' it stores the every key
    }

    // run a timeout of 200ms at the first read and clear everything
    if (!this.reading) {
      this.reading = true

      setTimeout(() => {
        this.code = ''
        this.reading = false
        this.fromScanner = false
      }, 200) // 200 works fine for me but you can adjust it
    }
  }
}
